module.exports = {"name":"treeLevels","type":"point","domain":{"signal":"sequence(maxLevel + 1)"},"range":"width"}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/scales/tree/levels.json
// module id = c/ux
// module chunks = 0